<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div style="display: flex;margin-top: 12px; align-items: flex-start;flex-direction: column;">
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form" style="margin-left: -14px;margin-right: -6px;margin-bottom: 15px; flex: 1;margin-top: 0px;">
              <div style="display:flex;margin: 2px 0;">
                <!-- Label -->
                <div class="table-search-form-flex label-type">
                  <div class="table-search-form-label">
                    {{"UID"}}
                  </div>
                </div>
                <div class="table-search-form-flex">
                  <div class="table-search-form-box">
                    <el-input v-model="searchForm.uid" :placeholder="'UID'"/>
                  </div>
                </div>
              </div>
              <div style="display:flex;margin: 2px 0;">
                <!-- Label -->
                <div class="table-search-form-flex label-type">
                  <div class="table-search-form-label">
                    {{$I18n("utd_ip")}}
                  </div>
                </div>
                <div class="table-search-form-flex">
                  <div class="table-search-form-box">
                    <el-input v-model="searchForm.utd_ip" :placeholder="$I18n('utd_ip')"/>
                  </div>
                </div>
              </div>
              <div style="display:flex;margin: 2px 0;">
                <!-- Label -->
                <div class="table-search-form-flex label-type">
                  <div class="table-search-form-label">
                    {{$I18n("p2p_ip")}}
                  </div>
                </div>
                <div class="table-search-form-flex">
                  <div class="table-search-form-box">
                    <el-input v-model="searchForm.p2p_ip" :placeholder="$I18n('p2p_ip')"/>
                  </div>
                </div>
              </div>
              <div style="display:flex;margin: 2px 0;">
                <div class="table-search-form-flex label-type">
                  <div class="table-search-form-label">
                    {{$I18n("last_fail_time")}}
                  </div>
                </div>
                <!-- 表单-日期范围选择-创建时间 -->
                <div class="table-search-form-flex">
                  <div class="table-search-form-box" style="width: 330px;">
                    <el-date-picker :picker-options="pickerOptions" v-model="searchForm.date" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                  </div>
                </div>
              </div>
              <div style="display:flex;margin: 2px 0;">
                <!-- Label -->
                <div class="table-search-form-flex label-type">
                  <div class="table-search-form-label">
                    {{$I18n("sort_type")}}
                  </div>
                </div>
                <div class="table-search-form-flex">
                  <div class="table-search-form-box">
                    <el-select v-model="searchForm.sort" :placeholder="$I18n('sort_type')">
                      <el-option :value="'dur'" :label="$I18n('dur')" />
                      <el-option :value="'traffic'" :label="$I18n('traffic')" />
                      <el-option :value="''" :label="$I18n('time')" />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex;align-items: center;padding-bottom: 6px;margin-left: -24px;">
              <!-- 按钮 {大屏幕模式} -->
              <div class="md-layout md-layout-item left-layout-item" :style="{'justify-content': 'flex-end','height':'36px'}">
                  <button class="left-icon md-info" @click="form_changeSearchData" style="margin-bottom: 0;">
                    <md-icon>search</md-icon>
                    {{$I18n("search")}}
                  </button>
                  <button class="left-icon md-info" @click="reset_serach" style="margin-bottom: 0;">
                    <md-icon>refresh</md-icon>
                    {{$I18n("reset")}}
                  </button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 分页 -->
    <div class="md-layout-item md-size-100" style="padding-top: 0;">
      <md-card style="margin: 0;">
        <div style="padding: 20px 20px 0;">
          <scroll-table height="calc(100vh - 420px)">
            <md-table class="diy-gray" v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell :md-label="'ID'">{{item.id}}</md-table-cell>
                <md-table-cell :md-label="'UID'">{{item.uid}}</md-table-cell>
                <md-table-cell :md-label="$I18n('dur')">{{item.dur}}</md-table-cell>
                <md-table-cell :md-label="$I18n('traffic')">{{item.traffic}}</md-table-cell>
                <md-table-cell :md-label="$I18n('client_type')">{{item.client_type_name}}</md-table-cell>
                <md-table-cell :md-label="$I18n('client_nettype')">{{item.client_nettype}}</md-table-cell>
                <md-table-cell :md-label="$I18n('dev_nettype')">{{item.dev_nettype}}</md-table-cell>
                <md-table-cell :md-label="$I18n('utd_ip')">{{item.utd_ip}}</md-table-cell>
                <md-table-cell :md-label="$I18n('p2p_ip')">{{item.p2p_ip}}</md-table-cell>
                <md-table-cell :md-label="$I18n('start_time')">{{item.start_time}}</md-table-cell>
                <md-table-cell :md-label="$I18n('end_time')">{{item.end_time}}</md-table-cell>
                <md-table-cell :md-label="$I18n('created_thing_time')">{{item.created_time}}</md-table-cell>
                <!-- 操作 -->
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
          </scroll-table>
        </div>
        <table-page-v2 :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </md-card>
    </div>
    <black-shadow-modal ref="image" :image="showImageSrc"/>
  </div>
</template>
<script>
// import {Tooltip as ElTooltip} from 'element-ui';
import BlackShadowModal from '@/components/Common/BlackShadowModal.vue';
import { timestampToString, nDaysAgo /* nMonthsAgo, FormClass */ } from "@/common/tools.js";
export default {
  components: {
    // ElTooltip,
    BlackShadowModal,
  },
  data() {
    return {
      showImageSrc: "",
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > new Date(nDaysAgo(-1));
        },
      },
      searchForm : { // 查询表单用的数据
        uid   : "",
        utd_ip: "",
        p2p_ip: "",
        date  : null,
        sort  : "",
      },
      searchData: {
        uid   : "",
        utd_ip: "",
        p2p_ip: "",
        sort  : "",
        gmt_start: "",
        gmt_end  : "",
      }, // 检索范围

      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      total    : 0,
      currentPage : 1,

      canReload: true, // 防止重复查询
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    pageSize(){
      this.api_getPageData(1);
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    bigImage(item){
      this.showImageSrc = item;
      this.$refs.image.open();
    },
    reset_serach(){
      this.searchForm = { // 查询表单用的数据
        uid   : "",
        utd_ip: "",
        p2p_ip: "",
        date  : [],
        sort  : "dur",
      }
    },
    strTotime(str){
      if(!str){
        return 0
      }
      return new Date(str).getTime() / 1000
    },
    form_changeSearchData(){
      console.log(this.searchForm)
      this.searchData = {
        uid   : this.searchForm.uid,
        utd_ip: this.searchForm.utd_ip,
        p2p_ip: this.searchForm.p2p_ip,
        sort  : this.searchForm.sort,
        gmt_start: this.searchForm.date ?this.strTotime(this.searchForm.date[0]) :0,
        gmt_end  : this.searchForm.date ?this.strTotime(this.searchForm.date[1].replace("00:00:00", "23:59:59")) :0,
      }
      this.api_getPageData(1);
    },
    // 获取页面信息
    api_getPageData(newPage){
      // 防止重复查询
      if(!this.canReload){
        return
      }
      this.canReload = false;
      if(newPage){
        this.currentPage = newPage
      }

      // 获取角色
      this.$api.getTraLogList({ // api: /v2/user/admin/feedback/list
          ...this.searchData,
          page_size: this.pageSize,
          page_no  : newPage ?newPage :this.currentPage,
      })
        .then(this.$Then(res => {
          this.canReload = true;
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.canReload = true;
          this.tableInitData = [];
          this.total = 0;
        }))
    },
  },
  computed: {
    tableData(){ // 表格数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          let client_type_name = this.$I18n("unknow");
          if(item.client_type === 0){
            client_type_name = this.$I18n("none")
          } else if(item.client_type == 1){
            client_type_name = "PC"
          } else if(item.client_type == 2){
            client_type_name = "iOS"
          } else if(item.client_type == 3){
            client_type_name = "Android"
          }

          return {
            ...item,
            client_type_name,
            start_time   :timestampToString(new Date(item.start_at).getTime()),
            end_time     :timestampToString(new Date(item.end_at).getTime()),
            created_time :timestampToString(new Date(item.created_at).getTime()),
          }
        });
      }
    },
  },
}
</script>
<style lang="css" scoped>
button.left-icon /deep/ i{
  color: #FFFFFF !important;
}
button.left-icon{
  background: #00bcd4;
  border: none;
  color: #FFFFFF;
  border-radius: 4px;
  line-height: 36px;
  height: 36px;
  padding: 0 30px;
  cursor: pointer;
}
/*.left-icon /deep/ .md-ripple{
  padding: 4px 30px !important;
}*/
.table-image-box{
  margin: 0 -5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.table-image{
  max-height: 34px;
  width: auto;
  max-width: 34px;
  margin: 0 5px;
}
.table-operate{
  width: 80px;
}
.table-ceil{
  display: inline-block;
  line-height: 36px;
  max-width: 15vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .md-card .md-subhead{
  opacity: 1 !important;
}
.order-card-title-span{
  color: #A5A5A5;
  padding-right: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
}
.order-info-body{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.order-info-body .md-layout-item>div{
  margin-bottom: 8px;
}
/deep/ .md-card-actions.md-alignment-right{
  border-top: 0 !important;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info{
  margin-bottom: 0px;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info .md-ripple{
  padding: 12px 16px;
}
/deep/ .md-card-actions.md-alignment-right{
  padding-top: 0 !important;
}
.md-table-md-button{
  height: 37px;
}
.table-search-form-box /deep/ .md-date-form-item{
  padding-right: 0 !important;
}
.table-search-form-box /deep/ .el-date-editor .el-range-input{
  width: 44%;
}
.table-search-form-box.none-clean /deep/ .el-date-editor .el-range-input{
  width: 47%;
}
.table-search-form-box.none-clean{
  padding-right: 8px;
}
.table-search-form-box.none-clean /deep/ .el-input__icon.el-range__close-icon{
  display: none;
}
</style>
<style lang="scss" scoped>
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .md-chip{
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;
  }
  .md-chip .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip:hover .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip.md-info{
    background: rgb(0, 188, 212) !important;
  }
  .md-chip.md-danger{
    background: #f44336 !important;
  }
  .md-info{
    margin-top : 0 !important;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    font-weight: 700;
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    font-size: 14px;
    font-weight: 400;
    font-family: Microsoft YaHei;
    color: #A5A5A5;
  }
  .order-card .foot-box .foot-box-right div{
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  .left-btn {
    text-align:left;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  @media screen and ( max-width: 600px ){
    .md-card .md-subhead {
      margin-left: 0;
    }
    .order-card-title span{
      display:block;
    }
    .foot-box span, .foot-box div{
      width: 50%;
      margin-right: -16px !important;
      margin-left: 16px !important;
    }
    .order-card{
      padding: 16px 0;
    }
  }
</style>
